<template>
<div>
    <BreadCrumb class="bread" :breads="['设备管理','理货任务','理货任务详情']"></BreadCrumb>
    <div class="header">
        <span class="nameFt">理货任务详情</span>
        <!-- <router-link :to="{path:'/index/deviceList'}"> -->
        <div @click="toDeviceList">
            <el-button class="addCustom" size="small" icon="el-icon-arrow-left">
                返回列表
            </el-button>
        </div>
        <!-- </router-link> -->
    </div>
    <div class="replenish-page">
        <el-date-picker v-model="value1" value-format="yyyy-MM-dd" size="small" type="date" :picker-options="pickerOptions" placeholder="选择日期">
        </el-date-picker>

        <!-- 勾选数据展示表格 -->
        <el-table :data="tableList" stripe style="width: 100%">
            <el-table-column label="序号" align="center" type="index" :index="indexMethod"></el-table-column>
            <el-table-column prop="hard_number" label="机器编号" align="center">
            </el-table-column>
            <el-table-column prop="line_name" label="线路名称" align="center">
            </el-table-column>
            <el-table-column prop="point_name" label="点位名称" align="center">
            </el-table-column>
            <el-table-column prop="terminal_number" label="设备编号" align="center">
            </el-table-column>
            <el-table-column prop="threshold_price" label="缺货金额" align="center">
            </el-table-column>
            <el-table-column prop="under_terminal" label="归属" align="center">
                <template slot-scope="scope">
                    <div v-if="scope.row.under_terminal==1" style="color:green">麦杰思</div>
                    <div v-if="scope.row.under_terminal==2" style="color:blue">轻购云</div>
                </template>

            </el-table-column>
            <el-table-column prop="bin_type" label="设备类型" align="center">
                <template slot-scope="scope">
                    <div v-if="scope.row.bin_type==0" style="color:green">单门柜</div>
                    <div v-if="scope.row.bin_type==1" style="color:blue">双门柜</div>
                </template>

            </el-table-column>
            <el-table-column prop="hard_number" label="商品操作" align="center" v-if="tableList.length == 1">
                <template slot-scope="scope">
                    <el-button size="small" type="text" @click="modifyItem(scope.row,scope.$index)">
                        更改补货商品数量
                    </el-button>
                </template>

            </el-table-column>

            <el-table-column prop="hard_number" label="操作" align="center">
                <template slot-scope="scope">
                    <el-button type="text" size="mini" @click="removeItem(scope.row)">移除</el-button>
                </template>
            </el-table-column>

        </el-table>

        <!-- 底部操作 -->
        <div style="margin-top: 20px; text-align: right;">
            <el-button type="danger" @click="clearAll" size="small">清空</el-button>
            <el-button type="primary" @click="submitData" v-if="tableList.length==1" size="small" :disabled="tableList.length==0">提交理货任务</el-button>
            <el-button type="primary" @click="submitDataMore" v-else size="small" :disabled="tableList.length==0">提交理货任务</el-button>
        </div>
    </div>
    <el-dialog class="dialogMY" :visible.sync="showDialog" width="80%" center>
        <div style="margin-bottom: 15px;">
            <el-radio-group v-model="threshold" @change="loadDisplayList">
                <el-radio :label="1">缺货陈列</el-radio>
                <el-radio :label="2">获取全部</el-radio>
            </el-radio-group>
        </div>
        <el-table :data="itemList" stripe style="width: 100%">
            <el-table-column label="序号" align="center" type="index" :index="indexMethod"></el-table-column>
            <el-table-column label="图片">
                <div slot-scope="scope">
                    <img :src="scope.row.image_url" width="80px" height="80px" />
                </div>
            </el-table-column>
            <el-table-column prop="name" label="商品名称" align="center">
            </el-table-column>
            <el-table-column prop="barcode" label="条形码" align="center">
            </el-table-column>
            <el-table-column prop="qty" label="容量" align="center">
            </el-table-column>
            <el-table-column prop="real_price" label="单价" align="center">
            </el-table-column>
            <el-table-column prop="details_qty" label="需要补货数量" align="center">
                <template slot-scope="scope">
                    <el-input v-model="scope.row.details_qty"> </el-input>
                </template>
            </el-table-column>
            <el-table-column prop="real_qty" label="真实数量" align="center">
            </el-table-column>
            <el-table-column prop="bin_type" label="设备类型" align="center">
                <template slot-scope="scope">
                    <div v-if="scope.row.bin_type ==0">单开门</div>
                    <div v-if="scope.row.bin_type ==1">左门</div>
                    <div v-if="scope.row.bin_type ==2">右门</div>
                </template>
            </el-table-column>
            <el-table-column prop="bin_type" label="操作" align="center">
                <template slot-scope="scope">
                    <el-button type="text" size="mini" @click="removeItemDialog(scope)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="showDialog = false">取 消</el-button>
            <el-button size="small" type="primary" @click="confirm">确 定</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import apis from "@/config/apis";

export default {
    components: {
        BreadCrumb,
    },
    data() {
        return {
            tableList: [],
            itemList: [],
            _itemList: [],
            showDialog: false,
            value1: '',
            pickerOptions: {
                disabledDate(time) {
                    // 禁用当前日期之前的所有日期
                    return time.getTime() < new Date(new Date().setHours(0, 0, 0, 0));
                }
            },
            threshold: 1,
            currentModifyRow: null,
            currentModifyIndex: null,
            formData: {
                hard_number: "",
                under_terminal: "",
                bin_type: "",
            }

        };

    },
    created() {
        const stored = localStorage.getItem("replenish_list");

        if (stored) {
            try {
                const list = JSON.parse(stored);

                // 判断解析出来是否为空数组
                if (Array.isArray(list) && list.length === 0) {
                    this.$message.warning("暂无补货单数据，请返回列表勾选后再进入。");
                    return;
                }

                this.tableList = list;
            } catch (err) {
                console.error("解析补货单数据失败：", err);
                this.$message.error("补货单数据异常，请重新选择。");
            }
        } else {
            // 本地根本没有存储
            this.$message.warning("暂无补货单数据，请返回列表勾选后再进入。");
        }
    },

    methods: {
        // ✅ 删除单条
        removeItem(row) {
            this.tableList = this.tableList.filter((item) => item.hard_number !== row.hard_number);
            this.saveToLocal();
        },
        // ✅ 清空全部
        clearAll() {
            this.$confirm("确定清空所有补货单数据？", "提示", {
                type: "warning",
            }).then(() => {
                this.tableList = [];
                localStorage.removeItem("replenish_list");
            });
        },
        // ✅ 保存到本地缓存（保持同步）
        saveToLocal() {
            localStorage.setItem("replenish_list", JSON.stringify(this.tableList));
        },
        // ✅ 提交
        submitData() {

            if (!this.tableList.length) {
                this.$message.warning("请先添加补货单数据！");
                return;
            }
            console.log("提交补货单数据：", this.tableList);
            this.$message.success("补货单提交成功！");
        },
        toDeviceList() {
            localStorage.removeItem("replenish_list");
            this.$router.push({
                name: 'deviceList'
            })
        },
        loadDisplayList() {
            let jsonData = {
                hard_number: this.formData.hard_number,
                under_terminal: this.formData.under_terminal,
                bin_type: this.formData.bin_type,
                threshold: this.threshold
            };

            this.$axios.post(apis.equipment_display, jsonData).then(res => {
                this.itemList = res.data.data;
            });
        },
        modifyItem(row, index) {
            this.formData.hard_number = row.hard_number;
            this.formData.under_terminal = row.under_terminal;
            this.formData.bin_type = row.bin_type;
            this.currentModifyRow = row;
            this.currentModifyIndex = index;
            this.showDialog = true;
            this.loadDisplayList();

            // this.currentModifyRow = row; // 记录当前被修改的行（引用）
            // let jsonData = {
            //     hard_number: this.formData.hard_number,
            //     under_terminal: this.formData.under_terminal,
            //     bin_type: this.formData.bin_type,
            //     threshold: this.threshold ? this.threshold : 1,

            // }
            // this.$axios.post(apis.equipment_display, jsonData).then(res => {
            //     this.showModifyDialog = true;
            //     this.itemList = res.data.data;
            // })
        },

        // update(row) {
        //     // let jsonData = {
        //     //     hard_number: row.hard_number,
        //     //     under_terminal: row.under_terminal,
        //     //     bin_type: row.bin_type,
        //     //     threshold: this.threshold,

        //     // }
        //     // this.$axios.post(apis.equipment_display, jsonData).then(res => {
        //     //     this.showDialog = true;
        //     //     this.itemList = res.data.data;
        //     // })
        // },
        confirm() {
            this.showDialog = false;
            // this._itemList = this.itemList;

        },
        selectModify() {

        },

        removeItemDialog(scope) {
            const index = scope.$index;
            const row = scope.row;

            this.$confirm(`确定删除 ${row.name || row.barcode || '该商品'} 吗？`, '提示', {
                    type: 'warning'
                })
                .then(() => {
                    // splice 会就地修改数组（Vue2 响应式），不需要重新赋值
                    this.itemList.splice(index, 1);
                    this.$message.success('已删除');
                })
                .catch(() => {
                    // 取消删除 — 什么也不做
                });
        },

        // removeItemDialog(scope) {
        //     this.itemList= this.itemList.splice(scope.$index,1);
        // },

        // ✅ 保存到本地缓存（保持同步）
        saveToLocal() {
            localStorage.setItem("replenish_list", JSON.stringify(this.tableList));
        },
        submitDataMore() {
            if (this.value1 == '') {
                this.$message.error('请选择日期')
            } else {
                const terminals = this.tableList.map(device => {
                    return {
                        hard_number: device.hard_number,
                        biz_type: device.biz_name,
                        line_name: device.line_name,
                        point_name: device.point_name,
                        under_terminal: device.under_terminal,
                    };
                });
                const jsonData = {
                    task_date: this.value1, // 你后面再赋值
                    terminals
                };

                this.$axios.post(apis.stock_up_task, jsonData).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success('新增成功')
                        localStorage.removeItem("replenish_list")
                        this.$router.push({
                            name: 'restock'
                        })
                    }
                })

            }

        },

        submitData() {
            if (this.value1 == '') {
                this.$message.error("请先选择日期")
            } else {
                const items = this.itemList.map(item => ({
                    real_price: item.real_price,
                    details_qty: item.details_qty,
                    barcode: item.barcode,
                    name: item.name,
                    image_url: item.image_url,
                    bin_no: item.bin_type
                }));

                const terminals = this.tableList.map(device => {
                    // 把每个设备的商品项映射成标准格式

                    // 返回该设备的完整信息
                    return {
                        hard_number: device.hard_number,
                        biz_type: device.biz_name,
                        line_name: device.line_name,
                        point_name: device.point_name,
                        under_terminal: device.under_terminal,
                        items: items // 嵌入上面生成的商品数组
                    };
                });

                // 组装成最终的 JSON
                const jsonData = {
                    task_date: this.value1, // 你后面再赋值
                    terminals
                };

                this.$axios.post(apis.stock_up_task, jsonData).then(res => {
                    if (res.data.code == 200) {
                        localStorage.removeItem("replenish_list")
                        this.$message.success('新增成功')
                        this.$router.push({
                            name: 'restock'
                        })
                    }
                })

            }

        },
    },
};
</script>

<style scoped>
.replenish-page {
    padding: 20px;
}
</style>
